var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_3086)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0001 13.5667C26.0001 12.6257 25.9151 11.7222 25.7589 10.8536H13.2656V15.9849H20.4052C20.0977 17.6433 19.163 19.0479 17.7583 19.9889V23.3169H22.046C24.5542 21.0075 26.0013 17.607 26.0013 13.5667H26.0001Z",
    fill: "#3E82F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2655 26.5311C16.8472 26.5311 19.8502 25.3427 22.0447 23.3169L17.757 19.9889C16.5685 20.785 15.0501 21.2549 13.2643 21.2549C9.80887 21.2549 6.88457 18.9217 5.84107 15.7862H1.41089V19.2229C3.59411 23.5581 8.07929 26.5311 13.2655 26.5311Z",
    fill: "#32A753"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.84235 15.7862C5.57741 14.9901 5.4262 14.1404 5.4262 13.2656C5.4262 12.3908 5.57741 11.541 5.84235 10.7449V7.30824H1.41091C0.512377 9.09906 0 11.1248 0 13.2656C0 15.4063 0.512377 17.4321 1.41091 19.2229L5.84235 15.7862Z",
    fill: "#F9BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2655 5.27623C15.2126 5.27623 16.9622 5.94607 18.3368 7.2595L22.1422 3.45417C19.844 1.31468 16.8409 0 13.2655 0C8.07929 0 3.59411 2.97304 1.41089 7.30824L5.84232 10.7449C6.88582 7.60942 9.81012 5.27623 13.2655 5.27623Z",
    fill: "#E74133"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_3086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26.5311,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolGoogle);
export default __webpack_public_path__ + "static/media/symbol-google.135c6b122f1c2ca5e1766bab0090a6c5.svg";
export { ForwardRef as ReactComponent };